import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import style from './styles/buyerPreQuotedOptions.scss';
import BuyerPreQuotedOption from './BuyerPreQuotedOption';

const BuyerPreQuotedOptions = ({
    deliveryOptions,
    shipmentType,
    shipmentQuoteId,
    onSelect,
    transaction,
    isComputing,
    viewer,
    preloadedDuties,
}) => (
    <div className={style.wrapper}>
        {deliveryOptions.map(preQuote => {
            const preQuoteId = get(preQuote, 'serviceId');
            const isSelected =
                shipmentType === 'FIRSTDIBS_FACILITATED' && shipmentQuoteId === preQuoteId;
            return (
                <BuyerPreQuotedOption
                    key={preQuoteId}
                    shipmentQuote={preQuote}
                    isSelected={isSelected}
                    onSelect={onSelect}
                    transaction={transaction}
                    isComputing={isComputing}
                    viewer={viewer}
                    preloadedDuties={preloadedDuties}
                />
            );
        })}
    </div>
);

BuyerPreQuotedOptions.propTypes = {
    deliveryOptions: PropTypes.array.isRequired,
    shipmentType: PropTypes.string.isRequired,
    preloadedDuties: PropTypes.object.isRequired,
    shipmentQuoteId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    transaction: PropTypes.object,
    isComputing: PropTypes.bool,
    viewer: PropTypes.object,
};

export default createFragmentContainer(BuyerPreQuotedOptions, {
    deliveryOptions: graphql`
        fragment BuyerPreQuotedOptions_deliveryOptions on ShipmentQuote @relay(plural: true) {
            ...BuyerPreQuotedOption_shipmentQuote
            serviceId
        }
    `,
    transaction: graphql`
        fragment BuyerPreQuotedOptions_transaction on Transaction {
            ...BuyerPreQuotedOption_transaction
        }
    `,
});
